export default "__VITE_ASSET__dc65b5b7__"